import z from "zod";

export const replySchema = z.object({
    response: z.string().nonempty({ message: "Required" }),
    additional: z.string().nullable().optional(),
});